import { render, staticRenderFns } from "./ShopProductPopup.vue?vue&type=template&id=21aaa1b7&"
import script from "./ShopProductPopup.vue?vue&type=script&lang=ts&"
export * from "./ShopProductPopup.vue?vue&type=script&lang=ts&"
import style0 from "./ShopProductPopup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports